import styled from "styled-components";

export const StyledModalContainerBG = styled.div``;

export const StyledModalContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledModalHeader = styled.div`
  font: inherit;
`;

export const StyledModalBody = styled.div`
  color: inherit;
  font: inherit;
`;

export const StyledModalFooter = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;
`;

export const StyledModalSubBody = styled.div`
  color: inherit;
  font: inherit;
`;
